import { ReactNode } from "react";

import { Content } from "./components";
import { AccountCreationContextProvider } from "./hooks";

export const AccountCreation = ({
    identityCobranding,
    ...props
}: {
    identityCobranding?: string;
    Error?: ReactNode;
    Input?: ReactNode;
    Login?: ReactNode;
    Separator?: ReactNode;
    Social?: ReactNode;
    Submit?: ReactNode;
}) => (
    <AccountCreationContextProvider identityCobranding={identityCobranding}>
        <Content {...props} />
    </AccountCreationContextProvider>
);
